import React from 'react';
import { motion } from 'framer-motion';
import AboutUs from '../components/UI/AboutUs';
import SEOHead from '../components/UI/SEOHead';

const AboutPage: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <SEOHead
        title="Nosotros"
        description="Conoce al equipo detrás de RurayHUB. Somos Ruray Digital, una startup ecuatoriana que ayuda a clínicas dentales a automatizar su WhatsApp con inteligencia artificial."
        path="/nosotros"
      />
      <AboutUs />
    </motion.div>
  );
};

export default AboutPage;
